module.exports = __webpack_public_path__ + "img/img-13.84c19b6f.png";